






































































































































































































































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';

// api
import API, { ApiResult } from '@/api/common';
import * as models from '@/class/models/views/group';

// validation
import * as validation from '@/personal/validation';

// components
import SideBarBase from '@/components/util/SideBarBase.vue';
import { ISelectOption } from '@/class/models/typed/wild';
import NewVariableInput, {INewVariableInput, INPUT_TYPE} from '@/components/util/NewVariableInput.vue';
import { strFuzzyMatch } from '@/class/common/util';
import SelectBox from '@/components/util/NewSelectBox.vue';
import CheckBoxList from '@/components/util/CheckBoxList.vue';

// parts
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';

export default Vue.extend({
  name: 'Group',
  components: { SideBarBase, NewVariableInput, SelectBox, CheckBoxList, ModalDeleteConfirm, ModalFormDataCheck},
  props: {
    confirmDialog: Function,
    ownerFlag : Boolean,
  },
  watch: {
    mode() {
      this.isProcessing = false;
    },
  },
  data() {
    return {
      onload: false,
      groupList: [] as models.IGroup[],
      groupUsedList: [] as models.IGroupUsed[],
      selectedGroupID: -1,
      selectGroup: {} as models.IGroup,
      editGroup: {} as models.IGroup,
      editUsers: [] as models.IGroupUsedUser[],
      selectGroupUsers: [] as models.IGroupUsedUser[],
      optionsDepartment: [ NOC.SELECT.ALL_DEPARTMENTS ] as ISelectOption[],
      inputedSearchDepartment: 0,
      inputedSearchName: '',
      searchDepartment: 0,
      searchName: '',
      mode: '',
      editItems: [
        {key: 'name', name: 'グループ名', placeholder: 'グループ名', type: INPUT_TYPE.TEXT, required: true, error: '', class: 'col-10', max: 20},
      ] as INewVariableInput[],
      tableItems: [] as any[],
      tableItemsSP: [] as any[],
      tableFields: [
        { key: 'checked', label: '' },
        { key: 'departmentParent', sortable: true, label: '親部署' },
        { key: 'departmentChild', sortable: true, label: '子部署' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      deleteShowFlag: false,
      isDefault: false, // SP初期表示時はdefault:true
      formDataChangeFlgModal: false,
      compEditGroup: {} as models.IGroup,
      compEditUsers: [] as models.IGroupUsedUser[],
      isProcessing: false, // 二重サブミット防止用
    };
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_EDIT_BASE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    MODE_CHARGE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.CHARGE);
    },
  },
  // 画面表示時処理
  async mounted() {
    this.mode = NOC.SETTING.MODE.CHARGE;
    this.$emit('pushPath', this.$route.path);
    const query = this.$route.query;
    const api = new API();
    const res = await api.get<models.VGroups>('group');
    if (res.result) {
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.groupList = res.data.groups;
      this.groupUsedList = res.data.groupUseds;

      // メインエリア初期表示
      if (query && query.id) {
        // ダッシュボードから遷移してきた場合
        const groupID = Number(query.id);
        const group = this.groupList.find((v) => v.groupID === groupID);
        if (group) {
          await this.onSelectSideList(group);
        }
        // URLをクエリなしに書き換え
        this.$router.replace('/setting/group');
      } else {
        if (query && query.md) {
          // ハンバーガーメニューから遷移してきた場合、サイドバー(SP)を初期表示する
          this.isDefault = true;
          // URLをクエリなしに書き換え
          this.$router.replace('/setting/group');
        }
        // 先頭のグループを初期表示
        if (this.groupList.length) {
          await this.onSelectSideList(this.groupList[0]);
        }
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }

    // 読み込み完了
    this.onload = true;
  },
  methods: {
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    getItemID(v: models.IGroup) {
      return v.groupID;
    },
    getItemText(v: models.IGroup) {
      return v.name;
    },
    // サイドバー項目選択処理
    async onSelectSideList(group: models.IGroup | null) {
      // if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
      //   return;
      // }
      this.resetEditData(); // リセット
      if (group) {
        // 基本情報表示
        this.selectedGroupID = group.groupID;
        this.selectGroup = group;
        // 登録ユーザーリスト表示
        const api = new API();
        const resUsers = await api.get<models.VGroupUsers>('group/users', {
          groupID: this.selectedGroupID,
        });
        if (resUsers.result) {
          this.selectGroupUsers = resUsers.data.users;
        }
      }
      this.mode = NOC.SETTING.MODE.NORMAL;
    },
    // 絞り込むボタン押下時処理
    onClickFilter() {
      this.searchDepartment = this.inputedSearchDepartment;
      this.searchName = this.inputedSearchName;
    },
    filteringUser(row: any, filter: any) {
      // すべての部署以外は親部署・子部署のどちらかにヒットしたら表示
      const matchDepartment =
        !filter.departmentID ||
        (
          row.departmentParentID === filter.departmentID ||
          row.departmentChildID === filter.departmentID
        );
      return matchDepartment &&
        (!filter.userName || strFuzzyMatch(filter.userName, row.user));
    },
    onCheckUser(data: models.IGroupUsedUser, checked: boolean) {
      for (const user of this.editUsers) {
        if (user.userID === data.userID) {
          user.checked = checked;
          break;
        }
      }
    },
    onCheckAllUser(checked: boolean) {
      for (const user of this.editUsers) {
        user.checked = checked;
      }
    },
    // 基本情報の編集ボタン押下時処理
    onClickEditBase() {
      this.mode = NOC.SETTING.MODE.EDIT_BASE;
      this.editGroup = JSON.parse(JSON.stringify(this.selectGroup));
      this.compEditGroup = JSON.parse(JSON.stringify(this.selectGroup));
    },
    // 登録ユーザーの編集ボタン押下時処理
    async onClickEditUser() {
      this.mode = NOC.SETTING.MODE.EDIT;
      await this.setAllUserList(this.selectedGroupID);
      // 編集ボタン押下時のユーザリストを退避
      this.compEditUsers = JSON.parse(JSON.stringify(this.compEditUsers));
    },
    // ユーザーリスト（チェックボックス付き）を設定
    async setAllUserList(groupID: number) {
      const api = new API();
      const resUsers = await api.get<models.VGroupUsers>('group/users', {
        groupID,
        isGetAll: true,
      });
      if (resUsers.result) {
        this.editUsers = resUsers.data.users;
        this.optionsDepartment = [NOC.SELECT.ALL_DEPARTMENTS].concat(resUsers.data.departments);
        this.compEditUsers = resUsers.data.users;
      }
      // テーブル表示文字列(PC)
      this.tableItems = JSON.parse(JSON.stringify(this.editUsers));
      for (const item of this.tableItems) {
        let user = `${item.sei} ${item.mei}`;
        if (item.mail) {
          user += ` (${item.mail})`;
        }
        item.user = user;
      }
      // テーブル表示文字列(SP)
      this.tableItemsSP = JSON.parse(JSON.stringify(this.editUsers));
      for (const item of this.tableItemsSP) {
        const user = `${item.sei} ${item.mei}`;
        item.user = user;
      }
    },

    // 戻る
    selectBack() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NORMAL;
      // this.isDefault = true;
      this.resetEditData();
    },
    // 次へからの戻る
    selectBackToNew() {
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // グループを追加
    addGroup() {
      this.mode = NOC.SETTING.MODE.NEW;
      this.editGroup = new models.CGroup();
      this.compEditGroup = new models.CGroup();
    },
    // 次へクリック時
    async onClickNext() {
      // 入力エラーが無ければ次へ
      if (!validation.checkValues(this.editGroup, this.editItems)) {
        this.mode = NOC.SETTING.MODE.SELECT;
        await this.setAllUserList(0); // チェックボックスの選択なし
      }
    },
    // 削除するクリック時
    openDeleteGroup() {
      this.deleteShowFlag = true;
    },
    // 削除モーダルクローズ
    closeModal() {
      this.deleteShowFlag = false;
    },
    // グループの削除実行
    async deleteGroup() {
      const api = new API();
      const res = await api.delete<models.VGroups>('group/delete', { deleteID: this.selectedGroupID });
      await this.processAfterUpdate(res);
      if (this.groupList.length > 0) {
        this.selectedGroupID = this.groupList[0].groupID;
      }
      this.isDefault = true;
    },
    // 基本情報の更新ボタン押下時処理
    async onClickRegistBase() {
      // validation
      if (validation.checkValues(this.editGroup, this.editItems)) {
        return false;
      }
      // 値を設定
      const requestData: models.VEditGroup = {
        group: this.editGroup,
      };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VEditGroup, models.VGroups>('group/edit/info', requestData);
      await this.processAfterUpdate(res);
    },
    // 登録ユーザーの更新ボタン押下時処理
    async onClickRegistUser() {
      // 値を設定
      const requestData: models.VGroup = {
        group: this.selectGroup, // this.editGroup,
        userIDs: this.editUsers.filter((v) => v.checked).map((v) => v.userID),
      };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VEditGroup, models.VGroups>('group/edit/used', requestData);
      await this.processAfterUpdate(res);
    },
    async onClickRegistNew() {
      // 値を設定
      const requestData: models.VGroup = {
        group: this.editGroup,
        userIDs: this.editUsers.filter((v) => v.checked).map((v) => v.userID),
      };
      // 登録実行
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<models.VGroup, models.VGroups>('group/new', requestData);
      await this.processAfterCreate(res);
    },
    // 更新後の後処理
    async processAfterUpdate(res: ApiResult<models.VGroups>) {
      if (res.result) {
        this.mode = NOC.SETTING.MODE.NORMAL;
        this.groupList = res.data.groups;
        this.groupUsedList = res.data.groupUseds;
        // 選択中のグループを再表示
        if (this.groupList.length) {
          this.selectedGroupID = this.selectGroup.groupID;
          let selected;
          selected = this.groupList.find((v) => v.groupID === this.selectedGroupID);
          if (!selected) {
            // グループ削除後
            if (this.groupList.length > 0) {
              // 1件以上あれば最初のグループを表示
              selected = this.groupList[0];
            } else {
              // 0件なら何も表示しない
              selected = null;
            }
          }
          this.onSelectSideList(selected);
        }
      } else {
        this.$emit('info', '登録できませんでした。');
      }
    },
    // 新規登録したグループを表示処理
    processAfterCreate(res: ApiResult<models.VGroups>) {
      if (res.result) {
        this.mode = NOC.SETTING.MODE.NORMAL;
        this.groupList = res.data.groups;
        this.groupUsedList = res.data.groupUseds;
        // 新規作成したIGroupを取得するため、配列の最後に存在することが必須
        const selected = this.groupList.slice(-1)[0];

        if (selected) {
          this.onSelectSideList(selected);
          this.mode = NOC.SETTING.MODE.SELECT;
        }
      } else {
        this.$emit('info', '登録できませんでした。');
        this.isProcessing = false;
      }
    },
    selectBackMenu() {
      window.scrollTo(0, 0);
      this.mode = '';
      this.isDefault = true;
    },
    selectBackGroup() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.isDefault = false;
    },
    // 編集データ破棄
    resetEditData() {
      this.editGroup = new models.CGroup();
      this.editUsers = [];
      this.optionsDepartment = [NOC.SELECT.ALL_DEPARTMENTS];
      this.searchDepartment = 0;
      this.searchName = '';
      this.inputedSearchDepartment = 0;
      this.inputedSearchName = '';
    },
    onClickClose() {
      // this.$emit('close');
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.isDefault = true;
      this.resetEditData();
    },
    formGroupDataChange() {
      let editGroupDataChangeFlg = false;
      // 編集ボタン押下時のグループ名と比較
      if (
        this.editGroup.name === this.compEditGroup.name
      ) {
        editGroupDataChangeFlg = false;
      } else {
        editGroupDataChangeFlg = true;
      }

      if (editGroupDataChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    formUserDataChange() {
      let editUsersFlg = false;
      // 編集ボタン押下時の登録ユーザーと比較
      for (let i = 0; i < this.compEditUsers.length; i++) {
        if (Boolean(this.tableItems[i].checked) === Boolean(this.compEditUsers[i].checked) &&
        Boolean(this.tableItemsSP[i].checked) === Boolean(this.compEditUsers[i].checked)) {
          editUsersFlg = false;
        } else {
          editUsersFlg = true;
          break;
        }
      }
      if (editUsersFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
  },
});
